import { UserWithBeltAndAddress } from '@/interfaces/UserWithBeltAndAddressInterface';

// Note that this is never null, where as in the Communfire/Gulp scripts it can be, 
// but from a Typescript & typechecking perspective this is not possible, so when checking
// for currentUser before using it, check the property you actually want to use, eg `if(currentUser.Email)...`
export const currentUser = {
	...window.thoughtCurrentUser,
} as UserWithBeltAndAddress;
